<template>
  <div ref="layout" class="page-query">
    <TableQuery title="营销中心产品开票量使用汇总表明细" @search="queryData" @reset="reset">
      <el-form inline class="form" size="mini" label-width="100px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="营销中心">
              <el-select
                v-model="conditions.customerType"
                placeholder="请选择"
                type="select"
                clearable
              >
                <el-option
                  v-for="item in selectDataOptions['A0009']"
                  :key="item.value"
                  :value="item.value"
                  :label="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="省份">
              <el-input
                v-model="conditions.orderCode"
                placeholder="请输入"
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="城市">
              <el-input
                v-model="conditions.customerCode"
                placeholder="请输入"
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发票类型">
              <el-select
                v-model="conditions.baseView"
                placeholder="请选择"
                type="select"
                clearable
              >
                <el-option
                  v-for="item in selectDataOptions['orgList']"
                  :key="item.baseCode"
                  :label="item.base"
                  :value="item.baseCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发票性质">
              <el-select
                v-model="conditions.baseView"
                placeholder="请选择"
                type="select"
                clearable
              >
                <el-option
                  v-for="item in selectDataOptions['orgList']"
                  :key="item.baseCode"
                  :label="item.base"
                  :value="item.baseCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否结清">
              <el-checkbox v-model="conditions.isEnd" true-label="1" false-label="0">是</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="订单客户" label-width="">
              <el-input
                v-model="conditions.orderCustomer"
                placeholder="请输入"
                clearable
                :style="{ width: '100%' }"
                @focus="openDialog($event, '客户选择', 2)"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="品牌">
              <el-input
                v-model="conditions.customerName"
                placeholder="请输入"
                disabled
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="产品名称">
              <el-input
                v-model="conditions.productName"
                suffix-icon="el-icon-more"
                @clear="conditions.productId = ''"
                @focus="openDialog($event, '产品选择')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="时间">
              <el-date-picker
                v-model="valDate"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                value-format="yyyy-MM-dd"
                end-placeholder="结束日期"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </TableQuery>

    <div class="table-container">
      <TableCommon
        title="结果清单"
        :custome-config="() => vxeShowCustom('xTable')"
        export-page
        :pagination="pagination"
        @pagination-change="handleTablePaginationChange"
        @exportExcel="exportExcel"
      >
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          align="center"
          size="mini"
          :loading="loading"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <!-- <template #toolbar /> -->
          <template v-for="item in gridOptions.columns" #[item.field]="{ row }">
            <div :key="item.field">
              <span>{{ row[item.field] }}</span>
            </div>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>

    <!-- 通用弹窗情况 -->
    <el-dialog v-dialogDrag :title="dialogTitle" :visible.sync="showDialog" width="70%" :append-to-body="true">
      <template v-if="showDialog">
        <product-select v-if="dialogTitle === '产品选择'" ref="dialogSelect" />
        <client-select v-if="dialogTitle === '客户选择'" ref="dialogSelect" />
      </template>

      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="submitHandle"
        >提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ActionUtils from '@/utils/action'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'

const ProductSelect = () => import('@/components/dialog/ProductSelect.vue')
const ClientSelect = () => import('@/components/dialog/ClientSelect.vue')
export default {
  components: {
    ProductSelect,
    ClientSelect
  },
  data() {
    return {
      valDate: null,
      loading: false,
      showDialog: false,
      dialogTitle: '',
      conditions: {},
      selectDataOptions: {},
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [
          { field: 'saleCenter', width: 120, title: '营销中心' },
          { field: 'saleCenter', width: 120, title: '省' },
          { field: 'saleCenter', width: 120, title: '市' },
          { field: 'saleCenter', width: 120, title: '开票客户编码' },
          { field: 'saleCenter', width: 120, title: '订单客户编码' },
          { field: 'saleCenter', width: 120, title: '品牌' },
          { field: 'saleCenter', width: 120, title: '产品名称' },
          { field: 'saleCenter', width: 120, title: '发票类型' },
          { field: 'saleCenter', width: 120, title: '发票性质' },
          { field: 'saleCenter', width: 120, title: '开票量' },
          { field: 'saleCenter', width: 120, title: '货权转移量' },
          { field: 'saleCenter', width: 120, title: '要货正在审批量' },
          { field: 'saleCenter', width: 120, title: '要货审批完成量' },
          { field: 'saleCenter', width: 120, title: '占用量合计' },
          { field: 'saleCenter', width: 120, title: '剩余量' }
        ],
        data: []
      }
    }
  },
  watch: {
    valDate(nV, oV) {
      this.conditions.endDate = nV ? nV[1] : ''
      this.conditions.startDate = nV ? nV[0] : ''
    }
  },
  created() {
  },
  methods: {
    queryData(page) {},
    reset() {},
    // 初始化数据字典
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 弹出框
    openDialog(e, title) {
      e.target.blur()
      this.showDialog = true
      this.dialogTitle = title
    },
    // 弹框提交时间
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()
      if (!data) return
      if (this.dialogTitle === '产品选择') {
        this.conditions.productId = data.productId
        this.conditions.productName = data.productShortName
      } else if (this.dialogTitle === '客户选择') {
        this.conditions.orderCust = data.customerCode
        this.conditions.orderCustName = data.customerName
      }
      this.showDialog = false
    },
    // 处理分页事件
    handleTablePaginationChange(page) {
      ActionUtils.setPagination(this.pagination, page)
      if (this.queryData) {
        this.queryData()
      }
    },
    // 数据导出
    exportExcel(type) {
      console.log(type)
    }
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/report-forms-manage/marketingCenterInvoiceUseDetailReportForms.vue